// 多语言路由配置
// 定义哪些页面需要多语言路由支持，哪些不需要

export interface RouteConfig {
  path: string;
  hasI18n: boolean;
  component: string;
}

// 有多语言支持的页面
export const I18N_ROUTES: string[] = [
  '/',
  '/how-to-play',
  '/privacy',
  '/about',
  '/contact'
];

// 没有多语言支持的页面（游戏页面等）
export const NON_I18N_ROUTES: string[] = [
  '/pokerogue',
  '/stickman-hook',
  '/monkey-mart',
  '/vex5',
  '/color-tunnel',
  '/capybara-clicker',
  '/pokemon-clicker',
  '/pokemon-clicker-2',
  '/time-shooter-3'
];

// 检查路径是否需要多语言路由
export const needsI18nRoute = (path: string): boolean => {
  return I18N_ROUTES.includes(path);
};

// 检查路径是否为非多语言路由
export const isNonI18nRoute = (path: string): boolean => {
  return NON_I18N_ROUTES.includes(path);
};

// 获取所有支持的语言代码
export const SUPPORTED_LANGUAGES = [
  'zh', 'ko', 'es', 'fr', 'pt', 'da', 'pl', 'ru', 
  'vi', 'th', 'fil', 'ja', 'no', 'nl', 'de', 'it', 'hi', 'ar'
];

// 检查是否为支持的语言代码
export const isSupportedLanguage = (lang: string): boolean => {
  return SUPPORTED_LANGUAGES.includes(lang);
};